if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.expandShowMore(event);
          const parentDisplay =
            event.target.closest('[id^="Show-More-"]')?.closest('.parent-display') ||
            event.target.closest('[id^="Show-More-"]')?.closest('[data-rb-shape-facet]') ||
            event.target.closest('[id^="Show-More-"]')?.closest('[data-rb-style-facet]');
          const nextElementToFocus = parentDisplay?.querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const showMoreRoot = event.target.closest('[id^="Show-More-"]');
        if (!showMoreRoot) return;
        const parentDisplay =
          showMoreRoot.closest('.parent-display') ||
          showMoreRoot.closest('[data-rb-shape-facet]') ||
          showMoreRoot.closest('[data-rb-style-facet]');
        if (!parentDisplay) return;
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
